import React, { Component } from 'react';
import Slider from 'react-slick';

import customSlideImg1 from 'images/custom-slide-img1.png';
import customSlideImg2 from 'images/custom-slide-img2.png';
import customSlideImg3 from 'images/custom-slide-img3.png';
import customSlideImg4 from 'images/custom-slide-img4.png';
import customSlideImg5 from 'images/custom-slide-img5.png';
import customSlideImg6 from 'images/custom-slide-img6.png';
import customSlideImg7 from 'images/custom-slide-img7.png';
import iPhone8Dark from 'images/iphone-transparent.svg';

const SLIDER_IMAGES = [
  {
    id: '1',
    src: customSlideImg5,
  },
  {
    id: '2',
    src: customSlideImg1,
  },
  {
    id: '3',
    src: customSlideImg3,
  },
  {
    id: '4',
    src: customSlideImg6,
  },
  {
    id: '5',
    src: customSlideImg2,
  },
  {
    id: '6',
    src: customSlideImg4,
  },
  {
    id: '7',
    src: customSlideImg7,
  },
];

const Slide = ({ imgSrc }) => {
  return (
    <div className="custom-slider__frame">
      <div className="custom-slider__img-inner">
        <div className="custom-slider__img-blur" />
        <img src={imgSrc} alt="" />
      </div>
    </div>
  );
};

class BrandSlider extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 700,
      autoplaySpeed: 3000,
      slidesToShow: 5,
      autoplay: true,
      focusOnSelect: true,
      touchMove: false,
      centerMode: true,
      centerPadding: '0px',
      pauseOnHover: true,
      pauseOnFocus: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    return (
      <div className="custom">
        <div className="h2-title big center">Customize to match your brand</div>
        <div className="custom__content">
          <div className="custom-slider">
            <div className="custom-slider__phone">
              <img src={iPhone8Dark} alt="" />
            </div>
            <Slider {...settings}>
              {SLIDER_IMAGES.map(dataImageSrc => (
                <Slide key={dataImageSrc.id} imgSrc={dataImageSrc.src} />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

export default BrandSlider;



// WEBPACK FOOTER //
// ./src/components/BrandSlider/BrandSlider.js